import {createAsyncThunk} from '@reduxjs/toolkit';

import {AIS3_SLICE} from 'store/slices/ais-slice/ais-slice-constants';
import {
    fetchOrganizationStructureData,
    saveOrganizationStructureDataRequest,
    ISaveOrganizationStructureDataRequestArgs,
} from 'store/slices/ais-slice/organization-structure/organization-structure-api';
import {TOrganizationStructureDto} from 'store/slices/ais-slice/organization-structure/organization-structure-types';

export const getOrganizationStructureData = createAsyncThunk<
    TOrganizationStructureDto, void>(
        `${AIS3_SLICE}/getOrganizationStructureData`,
        async (args, {rejectWithValue}) => {
            try {
                const response = await fetchOrganizationStructureData();
                const {data} = response;
                return data;
            } catch (e) {
                return rejectWithValue(e);
            }
        },
    );

export const saveOrganizationStructureData = createAsyncThunk<
    string, ISaveOrganizationStructureDataRequestArgs>(
        `${AIS3_SLICE}/saveOrganizationStructureData`,
        async (args, {rejectWithValue}) => {
            try {
                const response = await saveOrganizationStructureDataRequest(args);
                const {data} = response;
                return data;
            } catch (e) {
                return rejectWithValue(e);
            }
        },
    );
